import { captureException } from '@sentry/nextjs';
import api from 'src/utils/api';

export const fetchPopularNhsChoices = async () => {
  const { data } = await api.getPublic(`nhs-choices/communities/popular`)
    .catch((ex: Error) => {
      captureException(ex);
      return { data: [] };
    });

  return data;
};
